import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Options from '../components/Options';
import Packages from '../components/Packages';

class Widget extends React.Component {
	render() {
		const {
			deviceType,
			packages,
			options,
			showPricing,
			locale
		} = this.props;
		let optionsBorder;
		if (packages.length === 0 && options.length === 0) {
			return null;
		}

		if (packages.length > 0 && options.length > 0) {
			optionsBorder = <div className="my-4 border-top" />;
		}
		return (
			<div>
				<Packages
					deviceType={deviceType}
					packages={packages}
					widgetInfo={this.props.widgetInfo}
					showPricing={showPricing}
					locale={locale}
				/>
				{optionsBorder}
				<Options
					deviceType={deviceType}
					options={options}
					showPricing={showPricing}
					locale={locale}
				/>
			</div>
		);
	}
}

Widget.propTypes = {
	deviceType: PropTypes.string,
	locale: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired
		})
	),
	packages: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired,
			subitems: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
		})
	),
	showPricing: PropTypes.bool.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string,
		widgetName: PropTypes.string
	})
};

Widget.defaultProps = {
	deviceType: 'DESKTOP',
	locale: 'en_US',
	options: [],
	packages: [],
	widgetInfo: {
		windowId: 'packages-options1',
		widgetName: 'ws-packages-options'
	}
};

const mapStateToProps = state => {
	return {
		deviceType: state.requestData.deviceType,
		locale: state.requestData.locale,
		options: state.options,
		packages: state.packages,
		showPricing: state.settings.showPricing,
		widgetInfo: {
			windowId: state.requestData.windowId,
			widgetName: state.requestData.widgetName
		}
	};
};

const mapDispatchToProps = _dispatch => ({});

const WidgetContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(Widget);

export default WidgetContainer;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx